import '@castleio/castle-js/dist/castle.browser.js';
if (import.meta.env.VITE_CASTLE_PUBLISHABLE_KEY) {
  // eslint-disable-next-line no-undef
  Castle.configure({ pk: import.meta.env.VITE_CASTLE_PUBLISHABLE_KEY });
}
